import { useCallback, useEffect, useState } from 'react';
import { listReviews, listProductsForReviews, updateReview, deleteReview } from '../services/reviewService';

export function useReviews() {
  const [reviews, setReviews] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchAll = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const [reviewsData, productsData] = await Promise.all([listReviews(), listProductsForReviews()]);
      setReviews(reviewsData || []);
      setProducts(productsData || []);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAll();
  }, [fetchAll]);

  const saveReview = useCallback(
    async (review) => {
      await updateReview(review);
      await fetchAll();
    },
    [fetchAll]
  );

  const removeReview = useCallback(
    async (idReview) => {
      await deleteReview(idReview);
      await fetchAll();
    },
    [fetchAll]
  );

  return { reviews, products, loading, error, refetch: fetchAll, saveReview, removeReview };
}
